import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

class TagStore {
    tags = [];
    loading = false;
    error = null;
    user = null;
    auth = null;

    constructor() {
        makeAutoObservable(this);
    }

    // Set Bitrix data
    setUser(user) {
        this.user = user;
    }

    setAuth(auth) {
        this.auth = auth;
    }

    // Getter for headers
    get headers() {
        return {
            'X-Bitrix-User': this.user,
            'X-Bitrix-Auth': this.auth,
            'Content-Type': 'application/json'
        };
    }

    async fetchTags() {
        this.loading = true;
        this.error = null;
        try {
            const response = await axios.get(`${API_URL}/tags/`, {
                headers: this.headers
            });
            runInAction(() => {
                this.tags = response.data;
                this.loading = false;
            });
        } catch (error) {
            runInAction(() => {
                this.error = error.response?.data?.detail || 'Failed to fetch tags';
                this.loading = false;
            });
            console.error('Error fetching tags:', error);
        }
    }

    async createTag(tagData) {
        try {
            const response = await axios.post(`${API_URL}/tags/`, tagData, {
                headers: this.headers
            });
            runInAction(() => {
                this.tags.push(response.data);
            });
            return response.data;
        } catch (error) {
            const errorMsg = error.response?.data?.detail || 'Failed to create tag';
            console.error('Error creating tag:', error);
            throw new Error(errorMsg);
        }
    }

    async updateTag(id, tagData) {
        try {
            const response = await axios.put(`${API_URL}/tags/${id}`, tagData, {
                headers: this.headers
            });
            runInAction(() => {
                const index = this.tags.findIndex(t => t.id === id);
                if (index !== -1) {
                    this.tags[index] = response.data;
                }
            });
            return response.data;
        } catch (error) {
            const errorMsg = error.response?.data?.detail || 'Failed to update tag';
            console.error('Error updating tag:', error);
            throw new Error(errorMsg);
        }
    }

    async deleteTag(id) {
        try {
            await axios.delete(`${API_URL}/tags/${id}`, {
                headers: this.headers
            });
            runInAction(() => {
                this.tags = this.tags.filter(t => t.id !== id);
            });
        } catch (error) {
            const errorMsg = error.response?.data?.detail || 'Failed to delete tag';
            console.error('Error deleting tag:', error);
            throw new Error(errorMsg);
        }
    }

    getTagById(id) {
        return this.tags.find(t => t.id === id);
    }

    getTagsByIds(ids) {
        if (!ids || !Array.isArray(ids)) return [];
        return this.tags.filter(t => ids.includes(t.id));
    }
}

const tagStore = new TagStore();
export default tagStore;
